import dayjs from 'dayjs';

import { DB_DATE_FORMAT } from 'core/constants';
import { AgGridFilterOption } from 'core/enums';
import { QuoteEntityType } from 'quotes/enums';

export const getInitialState = (entityType = QuoteEntityType.QUOTE) => {
  switch (entityType) {
    case QuoteEntityType.ORDER:
      return {
        filter: {
          filterModel: {
            createdAt: {
              filterType: 'date',
              type: AgGridFilterOption.RELATIVE_LAST_30_DAYS,
            },
          },
        },
      };
    case QuoteEntityType.QUOTE:
    default:
      return {
        filter: {
          filterModel: {
            validUntil: {
              filterType: 'date',
              type: AgGridFilterOption.GREATER_THAN,
              dateFrom: dayjs().format(DB_DATE_FORMAT),
            },
          },
        },
      };
  }
};
